import axios from "axios";

const apiIam = axios.create({
  // baseURL: "http://localhost:8080",
  baseURL: process.env.REACT_APP_BOVEXO_IAM_URL,
  validateStatus: (status) => status >= 200 && status < 300,
});

export default apiIam;
